var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",attrs:{"id":"notfound-page"}},[_c('h2',[_vm._v("URL not FOUND")]),_c('router-link',{attrs:{"to":"/admin"}},[_vm._v(_vm._s(_vm.$t("commons.label.project_name")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }